<template>
    <div id="myDateShow">
        <div class="title">查看 会员资料</div>
        <div id="dataShow">
            <div class="line">
                <div class="key">基本信息</div>
            </div>
            <div class="line">
                <div class="key">会员类型</div>
                <div class="value">{{user.umsClassify}}</div>
            </div>
            <div class="line">
                <div class="key">会员昵称</div>
                <div class="value">{{user.username}}</div>
            </div>
            <div class="line">
                <div class="key">会员手机号</div>
                <div class="value">
                    <div class="value">{{user.phoneNumber}}</div>
                </div>
            </div>
            <div class="line">
                <div class="key">常用邮箱</div>
                <div class="value">{{user.email}}</div>
            </div>
            <div class="line">
                <div class="key">等级</div>
                <div class="value">{{user.xsaloLeave}}</div>
            </div>
            <div class="line">
                <div class="key">积能</div>
                <div class="value">{{user.nEnergy}}</div>
            </div>
            <div class="line">
                <div class="key">成长值（Gr）</div>
                <div class="value"><strong style="margin-right: 10px">Gr{{user.exp}}</strong>
                    备注：离下一个等级还差Gr{{user.upLeaveExp-user.exp}}
                </div>
            </div>
            <div class="line">
                <div class="key">注册时间</div>
                <div class="value">{{user.registerTime}}</div>
            </div>
            <div class="line">
                <div class="key">用户的分享码</div>
                <div class="value">{{user.shareCode}}</div>
            </div>
            <div class="line">
                <div class="key">发起支农体验</div>
                <div class="value">
                    {{user.inviterNum==null?'0':user.inviterNum}}次
                </div>
                <div class="value">
                    <el-button type="success" size="small" @click="gotoShare">查看详情</el-button>
                </div>
            </div>
            <div class="line">
                <div class="key">默认收货地址</div>
                <div class="value" v-if="user.defaultReceiveAddress!=null">
                    {{user.defaultReceiveAddress.provinceName}}{{user.defaultReceiveAddress.cityName}}{{user.defaultReceiveAddress.countyName}}{{user.defaultReceiveAddress.detailInfo}}
                </div>
            </div>
            <div class="line">
                <div class="key">状态</div>
                <div class="value" v-if="user.isSeal==0">
                    正常
                </div>
                <div class="value" v-if="user.isSeal==1">
                    被冻结
                </div>
                <div class="value" v-if="user.isSeal==2">
                    被禁用
                </div>
            </div>
            <div class="line">
                <div class="key"></div>
                <div class="value">
                    <el-button type="warning" size="small" @click="sealById">冻结</el-button>
                    <el-button type="success" size="small" @click="unsealById">解冻</el-button>
                    <el-button type="danger" size="small" @click="disableById">永久禁用</el-button>
                </div>
            </div>
            <div class="line"></div>

            <div class="line">
                <div class="key">推广信息</div>
            </div>
            <div class="line">
                <div class="key">推荐人</div>
                <div class="value">{{user.promotionName}}</div>
            </div>
            <div class="line">
                <div class="key">招募推广大使人数</div>
                <div class="value">{{user.promotionNumberPeople}}</div>
            </div>
            <div class="line">
                <div class="key">佣金收益金额</div>
                <div class="value">{{user.promotionCommissionRevenues}}</div>
            </div>
            <div class="line">
                <div class="key">已完成推广订单</div>
                <div class="value">{{user.completeCommissionOrderNum}}</div>
            </div>

<!--            <div class="line"></div>-->
<!--            <div class="line">-->
<!--                <div class="key">提现信息</div>-->
<!--            </div>-->
<!--            <div class="line">-->
<!--                <div class="key">开户行</div>-->
<!--                <div class="value">{{user.userDocument==null?"":user.userDocument.documentTypeText}}</div>-->
<!--            </div>-->
<!--            <div class="line">-->
<!--                <div class="key">开户网点</div>-->
<!--                <div class="value">{{user.userDocument==null?"":user.userDocument.accountOpeningBranch}}</div>-->
<!--            </div>-->
<!--            <div class="line">-->
<!--                <div class="key">银行卡号</div>-->
<!--                <div class="value">{{user.userDocument==null?"":user.userDocument.documentNumber}}</div>-->
<!--            </div>-->
<!--            <div class="line">-->
<!--                <div class="key">持卡人</div>-->
<!--                <div class="value">{{user.userDocument==null?"":user.userDocument.bindUserName}}</div>-->
<!--            </div>-->
<!--            <div class="line">-->
<!--                <div class="key">绑定手机号码</div>-->
<!--                <div class="value">{{user.userDocument==null?"":user.userDocument.bindPhoneNumber}}</div>-->
<!--            </div>-->

        </div>
        <div class="but">
            <el-button type="danger" size="small" @click="backClick">返回</el-button>
        </div>
    </div>
</template>

<script>
    import {getUserById, newVue, sealById, unsealById, disableById} from "../../network/user";

    export default {
        name: "userData",
        components: {},
        data() {
            return {
                userId: "",
                user: {}
            }
        },
        methods: {
            gotoShare() {
                this.$router.push("/share/list/" + this.user.shareCode);
            },
            sealById() {
                if (this.user.isSeal != 1) {
                    sealById(this.userId).then(res => {
                        getUserById(this.userId).then(res => {
                            this.user = res.data;
                        })
                    })
                }
            },
            unsealById() {
                if (this.user.isSeal != 0) {
                    unsealById(this.userId).then(res => {
                        getUserById(this.userId).then(res => {
                            this.user = res.data
                        })
                    })
                }
            },
            disableById() {
                if (this.user.isSeal != 2) {
                    disableById(this.userId).then(res => {
                        getUserById(this.userId).then(res => {
                            this.user = res.data
                        })
                    })
                }
            },
            backClick() {
                this.$router.push("../list");
            },
        },
        created() {
            newVue.obj = this;
            this.common.HeaderLocationTwo.href = "/user/list";
            this.common.HeaderLocationTwo.name = "注册会员管理"
            this.common.HeaderLocationThree.name = "注册会员详情"
            console.log(this.$route.params.id);
            this.userId = this.$route.params.id;

            getUserById(this.userId).then(res => {
                this.user = res.data
            })
        }
    }
</script>

<style scoped>
    @import "../../assets/css/data.css";
</style>
